import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, Phone, Mail, Search } from "lucide-react";

export default function Customers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/customers");
      setItems(data);
      setLoading(false);
    })();
  }, []);

  const filtered = items.filter((c) =>
    !search ? true : c.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6 lg:p-10 max-w-7xl mx-auto" data-testid="customers-page">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold tracking-tight text-[#0F172A]">Customers</h1>
        <p className="text-sm text-[#64748B] mt-1">
          Pelanggan yang tersinkron dari Accurate.id beserta nomor WhatsApp.
        </p>
      </div>

      <div className="relative max-w-sm mb-4">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Cari pelanggan..."
          data-testid="customer-search-input"
          className="w-full bg-white border border-[#E2E8F0] rounded-md pl-9 pr-3 py-2 text-sm focus:border-[#0066FF] focus:ring-1 focus:ring-[#0066FF] outline-none"
        />
      </div>

      <div className="border border-[#E2E8F0] rounded-lg bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F8F9FA]">
            <tr className="text-xs font-medium text-[#64748B] uppercase tracking-wider">
              <th className="px-6 py-3 text-left">Nama Pelanggan</th>
              <th className="px-6 py-3 text-left">WhatsApp</th>
              <th className="px-6 py-3 text-left">Email</th>
              <th className="px-6 py-3 text-center">Invoice Aktif</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E2E8F0]">
            {loading && (
              <tr>
                <td colSpan="4" className="px-6 py-12 text-center text-sm text-[#64748B]">
                  <Loader2 className="w-4 h-4 animate-spin inline mr-2" /> Memuat...
                </td>
              </tr>
            )}
            {!loading && filtered.length === 0 && (
              <tr>
                <td colSpan="4" className="px-6 py-12 text-center text-sm text-[#64748B]">
                  Tidak ada pelanggan.
                </td>
              </tr>
            )}
            {!loading &&
              filtered.map((c) => (
                <tr key={c.accurate_id} className="hover:bg-[#F8F9FA]" data-testid={`customer-row-${c.accurate_id}`}>
                  <td className="px-6 py-3 text-[#0F172A] font-medium">{c.name}</td>
                  <td className="px-6 py-3 text-[#475569]">
                    <span className="inline-flex items-center gap-1.5 font-mono text-xs">
                      <Phone className="w-3 h-3" /> {c.phone || "-"}
                    </span>
                  </td>
                  <td className="px-6 py-3 text-[#475569]">
                    <span className="inline-flex items-center gap-1.5">
                      <Mail className="w-3 h-3" /> {c.email || "-"}
                    </span>
                  </td>
                  <td className="px-6 py-3 text-center tabular-nums">
                    <span className="inline-block min-w-[28px] px-2 py-0.5 rounded-full bg-[#F1F5F9] text-[#475569] text-xs font-medium">
                      {c.active_invoices}
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
